
// React Resources
import React from 'react';


const CompaniesListContext = React.createContext([]);

export const CompaniesListProvider = CompaniesListContext.Provider;
export const CompaniesListConsumer = CompaniesListContext.Consumer;